// Cheat sheet for python modbus_scan.py, run inside the edge container.
// The flags belong to scada (ingress/modbus_scan.py, parse_args) -- when a
// flag or default changes there, update this file too.

export interface EdgeCommand {
  label: string
  command: string
}

export const EDGE_SCAN_COMMANDS: EdgeCommand[] = [
  { label: 'Pun sken, podešeni opseg (oko 3-10 min)', command: 'python modbus_scan.py --unit 1 --end 40' },
  { label: 'Samo coils, brzo', command: 'python modbus_scan.py --unit 1 --fc 1 --start 0 --end 16' },
  { label: 'Samo registri (izuzetak 04 se proba sa 2 registra i dekodira)', command: 'python modbus_scan.py --unit 1 --fc 3,4 --start 18 --end 27' },
  { label: 'Cela tabela, 0-255 (sporo)', command: 'python modbus_scan.py --unit 1' },
  { label: 'Otkrivanje mape: registri 0-999 (oko 20 min)', command: 'python modbus_scan.py --unit 1 --fc 3,4 --end 999 --discover' },
  { label: 'Otkrivanje mape brže: registri 0-999 na 50 ms (oko 5 min)', command: 'python modbus_scan.py --unit 1 --fc 3,4 --end 999 --discover --delay-ms 50' },
  { label: 'Otkrivanje mape: coils 0-999 (oko 20 min)', command: 'python modbus_scan.py --unit 1 --fc 1,2 --end 999 --discover' },
  { label: 'Koje jedinice (unit id) odgovaraju (oko 10 min)', command: 'python modbus_scan.py --units 1-247 --fc 1,3 --timeout 1' },
  { label: 'Prikaz poslednjeg izveštaja', command: 'ls -t /data/modbus-scan-*.txt | head -1 | xargs cat' },
  { label: 'Sve opcije', command: 'python modbus_scan.py --help' },
]

export interface EdgeCommandOption {
  flag: string
  description: string
}

export const EDGE_SCAN_OPTIONS: EdgeCommandOption[] = [
  { flag: '--delay-ms N', description: 'pauza između čitanja (min 50, podrazumevano 250)' },
  { flag: '--discover', description: 'otkrivanje mape na širokom opsegu: postojeći opsezi u blokovima, nepostojeće adrese jedna po jedna (oko jedno čitanje po nepostojećoj adresi)' },
  { flag: '--units a-b', description: 'umesto skena: jedno čitanje po unit id-ju (npr. 1-247), lista koji odgovaraju' },
  { flag: '--max-trims N', description: 'rekonekcije kad slave odseče vezu skena a ingress nije pogođen (podrazumevano 300, uz --discover/--units jedna po planiranom čitanju)' },
  { flag: '--max-reconnects N', description: 'rekonekcije kad je stanje ingress-a nepoznato (podrazumevano 10)' },
  { flag: '--no-upload', description: 'samo lokalni fajl, bez configured-vs-found poređenja' },
  { flag: '--host / --port', description: 'override ciljnog uređaja' },
]

export const EDGE_SCAN_NOTE = 'Jedinica 1 u komandama iznad je Mionicina — prilagodite --unit po potrebi.'
